/**
 * Internal dependencies
 */
import {
  isTextBoxAttachment,
  normalizeTextBoxAttachments,
} from '../../../utils/textBoxAttachment';

// Resolve the whole selection before publishing any frame. Drawing order can
// place a shadow before its image, so resolving individual pairs is insufficient.
function resolveAttachmentFrames(targetList, frames, units) {
  const { editorToDataX, editorToDataY, dataToEditorX, dataToEditorY } = units;
  const elements = targetList.map(({ element }, index) => {
    const frame = frames[index];
    return {
      ...element,
      x: element.x + editorToDataX(frame.translate[0]),
      y: element.y + editorToDataY(frame.translate[1]),
      width: frame.resize[0] ? editorToDataX(frame.resize[0]) : element.width,
      height: frame.resize[1] ? editorToDataY(frame.resize[1]) : element.height,
      rotationAngle: frame.rotate,
    };
  });
  normalizeTextBoxAttachments(elements).forEach((resolved, index) => {
    if (!isTextBoxAttachment(resolved.textBoxAttachment)) {
      return;
    }
    const { element } = targetList[index];
    frames[index].translate = [
      dataToEditorX(resolved.x - element.x),
      dataToEditorY(resolved.y - element.y),
    ];
  });
}

export default resolveAttachmentFrames;
